import prepareActionTypes from '../../helpers/prepareActionTypes';

export default prepareActionTypes(
  {
    LOAD: {
      INVALID: '',
      REQUESTING: '',
      FAILURE: '',
      SUCCESS: '',
    },
  },
  ['FILES']
);
